<template>
    <div>
        <h4 class="Table-font mt-2 mb-3 f-700"><i class="fa fa-table mr-2" aria-hidden="true"></i>Campus access log</h4>
        
        <b-tabs
            active-nav-item-class="font-weight-bold"
        >
            <b-tab active>
                <template v-slot:title>
                    <span class="h5 font-en text-capitalize text-dark"><i class="fa fa-tag mr-1" aria-hidden="true"></i>Check in / out</span>
                </template>
                <b-form class="mt-3 mb-0" inline>
                    <label class="text-dark mr-2"><i class="fa fa-search mr-2"></i></label>
                    <b-input style="width:50%" v-model="filter" type="search" id="filterInput" class="thai-font mb-2 mr-sm-2 mb-sm-0" placeholder="search..."></b-input>
                </b-form>
                <div class="row mt-3">
                    <div class="col-md-6">
                        <h6 class="mt-1 mb-2 text-capitalize">{{ countObjData }} records.</h6>
                        <b-pagination
                            id="my-table-checkIn"
                            class="font-thai"
                            v-model="currentPage"
                            :total-rows="countObjData"
                            :per-page="perPage"
                            @change="handlePageChange"
                        ></b-pagination>
                    </div>
                </div>
                <b-table
                    id="my-table-checkIn"
                    class="mt-2 Table-font font-500 text-dark" 
                    bordered hover striped responsive
                    :items="items"
                    :fields="fields"
                    :busy="isBusy"
                    show-empty
                    :filter="filter"
                    @filtered="onFiltered"
                    caption-top
                >
                    <template v-slot:table-busy>
                        <div class="thai-font text-center my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            Load covid19 check in - out list...
                        </div>
                    </template>
                    <template v-slot:cell(c4)="s4">
                        <i class="fa fa-lg mr-2" :class="{ 'text-danger fa-sign-out' : s4.value === 'out' , 'text-success fa-sign-in' : s4.value === 'in' }" ></i>
                    </template>
                </b-table>
            </b-tab>
            <b-tab v-if="this.$store.state.permit.RulesUser.roles.includes('staff')">
                <template v-slot:title>
                    <span class="h5 font-en text-capitalize text-dark"><i class="fa fa-clock-o mr-1" aria-hidden="true"></i>Time Attandance</span>
                </template>
                <div class="row">
                    <div class="col-md-8">
                        <b-form class="mt-3 mb-0" inline>
                            <label class="text-dark mr-2"><i class="fa fa-search mr-2"></i></label>
                            <b-input style="width:75%" v-model="filterAttandance" type="search" id="filterInput_2" class="thai-font mb-2 mr-sm-2 mb-sm-0" placeholder="search..."></b-input>
                        </b-form>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-6">
                        <h6 class="mt-1 mb-2 text-capitalize">{{ countObjDataAttandance }} records.</h6>
                        <b-pagination 
                            v-model="currentPageAttandance" 
                            :total-rows="countObjDataAttandance" 
                            :per-page="perPageAttandance" 
                            id="my-table-atandance"
                            @change="handlePageChange_2"
                        ></b-pagination>
                    </div>
                </div>
                <b-table
                    id="my-table-atandance"
                    class="mt-2 Table-font font-500 text-dark" 
                    bordered hover striped responsive
                    :items="itemsAttandance"
                    :fields="fieldsAttandance"
                    show-empty
                    :filter="filterAttandance"
                    @filtered="onFilteredAtt"
                ></b-table>
            </b-tab>
        </b-tabs>

    </div>
</template>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Baloo+Tamma+2&family=Varela+Round&display=swap');
    .Table-font{ font-family: 'Baloo Tamma 2', cursive; }
    .font-thai{ font-family: 'Kanit', sans-serif; font-weight: 100; }
    .font-en{ font-family: 'Rubik', sans-serif; font-weight: 300; }
    .form-control {
        background-color: #ffffff;
        border: 1px solid #ced4da;
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .font-500{ font-weight: 500; }
    .font-700{ font-weight: 700; }
    .f-size-btnexcel{ font-size: 1rem; }
    .f-size-verysmall{ font-size: 0.7rem; }
    .card-custom {
        /* Add shadows to create the "card" effect */
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
        transition: 0.3s;
        border-radius: 15px;
    }
    .tdW-10{ width:10% }
    .tdW-30{ width:30% }
</style>

<style>
    th {
        color: #fff;
        background-color: #7b6792;
        border-color: #454d55;
    }
    .card-header {
        padding: 0.75rem 1.25rem;
        margin-bottom: 0;
        background-color: rgb(255 255 255 / 3%);
        border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    }
</style>

<script>
    import store from "@/store/index";
    import Select2 from 'v-select2-component';
    export default {
        components: { Select2 },
        data() {
            return {
                fields: [
                    {
                        sortable: true, 
                        key: 'c4', 
                        label: 'Type',
                        class:'text-center',
                    },
                    {
                        sortable: true, 
                        key: 'c3', 
                        label: 'Device',
                        class:'text-center',
                    },
                    {
                        sortable: true, 
                        key: 'c1', 
                        label: 'Location',
                    },
                    {
                        sortable: true, 
                        key: 'c2', 
                        label: 'Building',
                    },
                    {
                        sortable: true, 
                        key: 'c5', 
                        label: 'Time stamp',
                        class:'text-right tdW-10',
                    },
                ],
                items: [],
                isBusy: false,
                // pagegination
                currentIndex: -1,
                perPage: 10,
                countObjData:0,
                currentPage: 1,
                offset: 0,
                bthNext:null,
                bthPrev:null,
                filter: null,
                filterOn: [],
                itemsAttandance: [],
                fieldsAttandance: [
                    {
                        sortable: true, 
                        key: 'c', 
                        label: 'Date',
                        class:'text-center',
                    },
                    {
                        sortable: true, 
                        key: 'c1', 
                        label: 'Time stamp',
                        class:'text-center',
                    },
                    {
                        sortable: true, 
                        key: 'c2', 
                        label: 'Remark',
                        class:'text-center',
                        thStyle: 
                        { 
                            width:'50%',
                        }
                    },
                ],
                countObjDataAttandance:0,
                offsetAttandance: 0,
                perPageAttandance: 10,
                currentPageAttandance: 1,
                filterAttandance: null,
                filterOnAttandance: [],
            }
        },
        computed:{
            // rows() { return this.items.length },
            rowsAtt() { return this.itemsAttandance.length },
            sortOptions() {
                return this.fields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key }
                })
            }
        },
        mounted(){
            this.callTokenDetail()
            this.callAttandance()
        },
        methods: {
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            onFilteredAtt(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPageAttandance = 1
            },
            handlePageChange(value) {
                this.currentPage = value
                this.offset = parseInt(value-1)*parseInt(this.perPage);
                this.callTokenDetail()
            },
            async callTokenDetail(){
                this.isBusy = true
                try {
                    const res = await this.$http.get(`/checkcovid19/QR/history/?limit=${this.perPage}&offset=${this.offset}`)
                    if (res.status === 200) {
                        this.items = res.data.results.map(item => {
                            return {
                                'id': item.id,
                                'c': item.staff_id,
                                'c0': item.staff_name,
                                'c1': item.location_detail.location, 
                                'c2': item.location_detail.building,
                                'c3': item.input_type.toUpperCase(),
                                'c4': item.location_detail.check_type,
                                'c5': this.moment(item.created_at).format('LLL'),
                            }
                        })
                        this.items.sort((a, b) =>{ return b.id - a.id; });
                        this.countObjData = res.data.count
                        this.offset = 0
                        this.isBusy = false
                    }
                } catch (error) {
                    this.isBusy = false
                }
            },
            handlePageChange_2(value) {
                this.currentPageAttandance = value
                this.offsetAttandance = parseInt(value-1)*parseInt(this.perPageAttandance);
                this.callAttandance()
            },
            async callAttandance(){
                this.itemsAttandance = []
                try {
                    const res = await this.$http.get(`/hri/time_attendance/?limit=${this.perPageAttandance}&offset=${this.offsetAttandance}`)
                    if (res.status === 200) {
                        this.itemsAttandance = res.data.results.map(item => {
                            return {
                                'id': item.id,
                                'location': item.location,
                                'c': this.moment(item.created_at).format('MMMM Do YYYY'),
                                'c1': this.moment(item.created_at).format('LTS'),
                                'c2': item.remark,
                            }
                        })
                        this.itemsAttandance.sort((a, b) =>{ return b.id - a.id; });
                        this.countObjDataAttandance = res.data.count
                        this.offsetAttandance = 0
                    }
                } catch (error) {}
            },
        }
    }
</script>